import { render, staticRenderFns } from "./bulma_sectionsprops.vue?vue&type=template&id=7a149c32"
import script from "./bulma_sectionsprops.vue?vue&type=script&lang=js"
export * from "./bulma_sectionsprops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports